<template>
  <span>
    <DaiCapaGeojson
      url="data/capas/actores_por_estados_mx.geojson"
      :estilo-capa="{
        fill: { color: 'transparent' },
        stroke: { color: '#B2B2B2' },
      }"
      :z-index="2"
      :zoom-al-dar-click="false"
    />

    <DaiCapaGeojson
      :id="idCapa"
      url="data/capas/actores_por_estados_mx.geojson"
      :estilo-capa="{
        fill: { color: 'transparent' },
        stroke: { color: 'transparent' },
      }"
      :z-index="4"
      :contenidoTooltip="
        (f) =>
          `País: México<br />` +
          `Estado: ${f.nom_ent}<br />` +
          `Personas por ubicación | ${f.num_actores}<br />`
      "
      @click_feature="([f]) => cambiarCvesEdo(f.get('cve_ent'))"
      :zoom-al-dar-click="false"
    />
  </span>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import { ID_CAPA, obtenerFeatureExtent } from "@/components/mapas/utiles";

export default {
  data: () => ({
    idCapa: ID_CAPA.estados,
  }),
  methods: {
    ...mapMutations("mapaActores", ["cambiarExtensionMapa"]),
    ...mapActions("mapaActores", ["cambiarCvesEdo"]),
    obtenerExtentDelEstadoActual() {
      return obtenerFeatureExtent(
        this.$parent.cmpLayers[ID_CAPA.estados].olLayer,
        (feature) => feature.getProperties().cve_ent === this.actualCveEdo
      );
    },
  },
  watch: {
    actualCveEdo(newVal) {
      if (newVal === undefined) {
        // no hay selección estatal
        // console.log("resetear zoom estatal");
      } else {
        // console.log(`Cambiar estado a: ${newVal}`);
        this.cambiarExtensionMapa(this.obtenerExtentDelEstadoActual());
      }
    },
  },
  computed: {
    ...mapGetters("mapaActores", ["actualCveEdo"]),
  },
};
</script>
